// ADHDROOM product page (sections/adr-product.liquid).
// Choosing options picks the matching variant: price, availability, photo and the ?variant= address follow.
// Add to cart goes through the ADHDROOM cart (assets/adr-chrome.js): the photo flies into the bag, no page change.

(function () {
  var root = document.querySelector('[data-adr-product]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-pdp-json]').textContent);
  var form = root.querySelector('[data-pdp-form]');
  var idInput = form.querySelector('input[name="id"]');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var addBtn = form.querySelector('[data-pdp-add]');
  var addText = form.querySelector('[data-pdp-add-text]');
  var priceEl = root.querySelector('[data-pdp-price]');
  var errorEl = root.querySelector('[data-pdp-error]');
  var mainImg = root.querySelector('[data-pdp-main]');
  var thumbs = root.querySelectorAll('.pdp-thumb');
  var fieldsets = form.querySelectorAll('.pdp-option');

  // Prices in the visitor's currency, written like the rest of the page (assets/adr-chrome.js)
  function money(cents) {
    if (window.ADRMoney) return window.ADRMoney(cents);
    var fmt = data.money_format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = cents / 100;
    function num(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = num(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(value, 0, '.', ','); break;
      default: out = num(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  function selected() {
    return Array.prototype.map.call(fieldsets, function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function find(opts) {
    return data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  }

  function showImage(src) {
    if (!src || !mainImg) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
    thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-src') === src); });
  }

  // grey out values that have no available variant with the other current choices
  function markAvailability(opts) {
    fieldsets.forEach(function (fs, i) {
      fs.querySelectorAll('.pdp-pill').forEach(function (pill) {
        var val = pill.querySelector('input').value;
        var ok = data.variants.some(function (v) {
          return v.available && v.options[i] === val && v.options.every(function (o, j) { return j === i || o === opts[j]; });
        });
        pill.classList.toggle('is-out', !ok);
      });
    });
  }

  function update(fromUser) {
    var opts = selected();
    var v = fieldsets.length ? find(opts) : data.variants[0];
    markAvailability(opts);
    if (!v) {
      addBtn.disabled = true;
      addText.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    priceEl.innerHTML = '<strong>' + money(v.price) + '</strong><span class="currency">' + data.currency + '</span>' +
      (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
    // gift cards: the amount on the brand card follows the chosen amount
    var gcAmount = root.querySelector('[data-gc-amount]');
    if (gcAmount) gcAmount.textContent = money(v.price).replace(/[.,]00(?=\D*$)/, '');
    // gifting the course: its amount gets a note, and the card says what it's for
    root.querySelectorAll('[data-gift-course-note], [data-gc-for]').forEach(function (el) { el.hidden = !v.course; });
    addBtn.disabled = !v.available;
    addText.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (fromUser) {
      if (v.image) showImage(v.image);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(null, '', url.toString());
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target.closest('.pdp-option')) update(true);
  });

  form.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = (parseInt(qtyInput.value, 10) || 1) + +b.getAttribute('data-qty');
      qtyInput.value = Math.max(1, n);
    });
  });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showImage(t.getAttribute('data-src')); });
  });

  // Gift cards: "Send it to someone" shows the recipient fields; only then are they sent with the card
  var giftToggle = form.querySelector('[data-gift-toggle]');
  var giftFields = form.querySelector('[data-gift-fields]');
  function syncGift() {
    if (!giftToggle || !giftFields) return;
    giftFields.hidden = !giftToggle.checked;
    giftFields.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !giftToggle.checked; });
    var email = giftFields.querySelector('input[type="email"]');
    if (email) email.required = giftToggle.checked;
    var offset = giftFields.querySelector('[data-gift-offset]');
    if (offset) offset.value = new Date().getTimezoneOffset();
  }
  if (giftToggle) { giftToggle.addEventListener('change', syncGift); syncGift(); }
  function properties() {
    var out = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      if (el.disabled || (el.type === 'checkbox' && !el.checked) || el.value === '') return;
      out[el.name.slice(11, -1)] = el.value;
    });
    return out;
  }

  form.addEventListener('submit', function (e) {
    if (!window.ADRCart) return; // without the cart script, the form posts to /cart/add as normal
    e.preventDefault();
    if (addBtn.disabled || addBtn.classList.contains('is-busy')) return;
    addBtn.classList.add('is-busy');
    errorEl.hidden = true;
    window.ADRCart.add(idInput.value, Math.max(1, parseInt(qtyInput.value, 10) || 1), mainImg, properties())
      .catch(function (err) {
        errorEl.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added.';
        errorEl.hidden = false;
      })
      .finally(function () { addBtn.classList.remove('is-busy'); });
  });

  // Arriving from the course page (?for=course): the course amount is already chosen
  if (/[?&]for=course(&|$)/.test(window.location.search)) {
    var gift = data.variants.filter(function (v) { return v.course; })[0];
    if (gift) {
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) { input.checked = input.value === gift.options[i]; });
      });
    }
  }

  update(false);
})();
